export default __webpack_public_path__ + "static/media/480_dummy2016-mode01-de.2a89fe7f.png";